import { createContext, useContext } from 'react';

interface NavHeightContextType {
	navHeight: number;
	setNavHeight: (height: number) => void;
}

export const NavHeightContext = createContext<NavHeightContextType | undefined>(
	undefined
);

export const useNavHeight = () => {
	const context = useContext(NavHeightContext);
	if (!context) {
		throw new Error('useNavHeight must be used within a NavHeightProvider');
	}
	return context;
};
